import styled from '@emotion/styled';
import Button from '@portalterreno/react-ui-core/Button';

const ArrowButton = styled(Button)(
  {
    borderRadius: '50%',
    display: 'inline-flex',
    padding: 4,
    margin: 4
  },
  ({ theme }) => ({
    border: `solid ${theme.palette.colors.columbiaBlue} 1px`,
    backgroundColor: theme.palette.colors.white,
    color: theme.palette.colors.coolGrey
  })
);

export default ArrowButton;
